import { memo, useState } from 'react';
import { Stack, Text } from '@chakra-ui/react';

import RequirementMatchCollapsible from './RequirementMatchCollapsible';
import { ScreeningAnalysisResult } from '@/types/AnalysisResult';

interface RequirementsMatchSectionProps {
  analysisResult: ScreeningAnalysisResult;
}

const StrengthsAndConcernsSection = memo(({ analysisResult }: RequirementsMatchSectionProps) => {
  const [alignedItemsOpen, setAlignedItemsOpen] = useState(true);
  const [gapsOpen, setGapsOpen] = useState(true);

  return (
    <Stack>
      <Text color="neutrals.900" fontSize="18px" fontWeight="semibold" mb="8px">
        Strengths and Concerns
      </Text>
      <Text fontSize="16px" color="neutrals.700" mb="24px">
        This section compares the candidate's resume with the job description to highlight aligned
        and misaligned skills for quick suitability assessment.
      </Text>
      <RequirementMatchCollapsible
        title="Strengths"
        matchType="aligned"
        items={analysisResult.strengths}
        isOpen={alignedItemsOpen}
        setOpen={setAlignedItemsOpen}
      />
      <RequirementMatchCollapsible
        title="Concerns or Gaps"
        matchType="misaligned"
        items={analysisResult.concerns_or_gaps}
        isOpen={gapsOpen}
        setOpen={setGapsOpen}
      />
    </Stack>
  );
});

StrengthsAndConcernsSection.displayName = 'StrengthsAndConcernsSection';

export default StrengthsAndConcernsSection;
